import { maskCurrency } from 'src/utils/convertCurrency'
import { HideBalanceDotsIcon } from 'src/components/Icons/HideBalanceDots'
import { CashBackIcon } from 'src/components/Icons/CashbackIcon'
import { useAccountContext } from 'src/components/account/context'

type CashBackDataProps = {
  variant: 'home' | 'account'
}

const CashbackBalance = ({ variant }: CashBackDataProps) => {
  const { cashBackBalance, isLoggedIn } = useAccountContext()

  return variant === 'account' ? (
    <div className="w-full h-[82px] border border-[#D9DDE1] font-inter text-[#616161]">
      <div className="w-[106px] h-[18px] mt-[14px] ml-[20px] font-inter font-normal text-[12px] leading-[18px]">
        Saldo cashback
      </div>
      <div className="w-[139px] h-[32px] mt-[4px] ml-[20px]">
        <div className="font-inter font-medium text-[24px] leading-[32px] text-[#101010] flex items-center gap-2">
          {isLoggedIn ? (
            <>
              {maskCurrency(cashBackBalance ?? 0)}
              <div className="ml-[4px]">
                <CashBackIcon />
              </div>
            </>
          ) : (
            <>
              <span className="font-inter">R$</span>
              <HideBalanceDotsIcon />
            </>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div className="restructure-tablet:rounded-t-lg px-6 py-4 w-full bg-restructure-background-action-1 font-inter text-white flex flex-col gap-2 restructure-tablet:block">
      <span className="text-font-size-2 restructure-tablet:text-xs">
        Cashback disponível
      </span>
      <div className="text-xl leading-none restructure-tablet:leading-7">
        <span className="font-inter">
          {isLoggedIn ? (
            maskCurrency(cashBackBalance ?? 0)
          ) : (
            <div className="flex gap-2 items-center">
              <span className="font-inter">R$</span>
              <HideBalanceDotsIcon />
            </div>
          )}
        </span>
      </div>
    </div>
  )
}

export default CashbackBalance
